/** @format */



import { lazyWithRetry } from "@/shared/lib/lazy-with-retry"
// Eager imports for always-needed routes
import Login from './Login'
import Home from './Home'

// Lazy imports for code-split routes
const DataLibrary = lazyWithRetry(() => import('./DataLibrary'))
const Category = lazyWithRetry(() => import('./DataLibrary/Category'))
const Measurement = lazyWithRetry(() => import('./DataLibrary/Measurement'))
const GlassThickness = lazyWithRetry(() => import('./DataLibrary/GlassThickness'))
const Materials = lazyWithRetry(() => import('./DataLibrary/Materials'))
const Company = lazyWithRetry(() => import('./DataLibrary/Company'))
const Branches = lazyWithRetry(() => import('./DataLibrary/Branches'))
const Warehouse = lazyWithRetry(() => import('./DataLibrary/Warehouse'))
const Departments = lazyWithRetry(() => import('./DataLibrary/Departments'))
const Positions = lazyWithRetry(() => import('./DataLibrary/Positions'))
const Employees = lazyWithRetry(() => import('./DataLibrary/Employees'))
const Roles = lazyWithRetry(() => import('./DataLibrary/Roles'))
const Lables = lazyWithRetry(() => import('./DataLibrary/Lables'))
const Regions = lazyWithRetry(() => import('./DataLibrary/Region'))
const Districts = lazyWithRetry(() => import('./DataLibrary/Districts'))
const Customers = lazyWithRetry(() => import('./DataLibrary/Customers'))
const WarehousesPage = lazyWithRetry(() => import('./Warehouse/WarehousesPage'))
const RequestsInSupply = lazyWithRetry(() => import('@/features/supply-request-order'))
const AllOrdersInSupply = lazyWithRetry(() => import('@/features/supply-all-orders'))
const EditAllRequestOrder = lazyWithRetry(() => import('@/features/supply-all-orders/ui/AddEdit'))
const ApprovementSignature = lazyWithRetry(() => import('@/features/approvement-signature'))
const Signatories = lazyWithRetry(() => import('@/features/signatures'))
const MinMaxPercentage = lazyWithRetry(() => import('@/features/min-max-percentage'))

export {
  Login,
  Home,
  DataLibrary,
  Category,
  Measurement,
  GlassThickness,
  Materials,
  Company,
  Branches,
  Warehouse,
  Departments,
  Positions,
  Employees,
  Roles,
  Lables,
  Regions,
  Districts,
  Customers,
  WarehousesPage,
  RequestsInSupply,
  AllOrdersInSupply,
  EditAllRequestOrder,
  ApprovementSignature,
  Signatories,
  MinMaxPercentage,
}
